import { BaseReactiveClass } from 'Classes/BaseReactiveClass';

export class ModelAccountController extends BaseReactiveClass {
  static STATUS_SUCCESS = 'success';
  static STATUS_NEW = 'new';

  static LINK_TYPE_GRANTOR = 'grantor';

  get isStatusSuccess() {
    return this.status === ModelAccountController.STATUS_SUCCESS;
  }

  get isStatusNew() {
    return this.status === ModelAccountController.STATUS_NEW;
  }

  get isGrantor() {
    return this.link === ModelAccountController.LINK_TYPE_GRANTOR;
  }
}
